<template>
  <div class="solution">
      solution
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "solution",
  components: {}
};
</script>
<style lang="scss" scoped>
</style>
